import pluralize from "pluralize";
import React, {useRef} from "react";

import {thousandSeparatedInt} from "@/lib/format.tsx";
import {MonitoringServiceType} from "@/lib/types/checks.ts";
import {
  LimitCheckProps,
  LimitCheckWithInstantCheckout,
  LimitCheckWithInstantCheckoutComponent,
} from "@/pages/billing/v2/InstantCheckout/LimitCheckWithInstantCheckout.tsx";
export interface LimitCheckServiceLimitProps {
  serviceType?: MonitoringServiceType;
  serviceCountIncrement?: number;
  onUpgradeSuccess?: () => void;
  triggerContext?: string;
}

export const LimitCheckServiceLimit = React.forwardRef(
  ({serviceType, serviceCountIncrement = 1, onUpgradeSuccess, triggerContext}: LimitCheckServiceLimitProps, ref) => {
    const checkerRef = useRef<LimitCheckWithInstantCheckoutComponent>();
    const checkIfLimitHit = (props?: LimitCheckProps) => {
      return checkerRef.current?.checkIfLimitHit(props);
    };
    React.useImperativeHandle(ref, () => ({
      checkIfLimitHit,
    }));
    return (
      <LimitCheckWithInstantCheckout
        getUpgradeMessage={(hasSubscription, limitName) =>
          `${!hasSubscription ? "Subscribe" : "Upgrade"} now to allocate more ${pluralize(limitName)} to your account.`
        }
        getRequestMessage={(hasSubscription) =>
          `If you would like to ${!hasSubscription ? "request a subscription" : "upgrade your account"} to allocate additional Checks, please send a request to the owner of this account below to upgrade.`
        }
        getReasonMessage={(hasSubscription, limitName, limitValue) =>
          !hasSubscription
            ? `You have reached the limit of ${thousandSeparatedInt(limitValue)} ${pluralize(limitName, limitValue)} available on your Free Trial`
            : `You have reached your account limit of ${thousandSeparatedInt(limitValue)} ${pluralize(limitName, limitValue)}`
        }
        getTitleMessage={(hasSubscription) => `${hasSubscription ? "Upgrade" : "Subscribe"} to add new Checks`}
        serviceType={serviceType}
        requestedIncrement={serviceCountIncrement}
        onUpgradeSuccess={onUpgradeSuccess}
        triggerContext={triggerContext}
        ref={checkerRef}
      />
    );
  }
);
